import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import './modal.scss';

const Modal = ({ show, setShow, onClose, children }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  if (!show) return null;

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      if (onClose) {
        onClose();
        return;
      }

      if (setShow) {
        setShow(false);
      }
    }
  };

  const handleMouseDown = (event) => {
    if (event.target === event.currentTarget) {
      if (onClose) {
        onClose();
        return;
      }

      if (setShow) {
        setShow(false);
      }
    }
  };

  return (
    <article className="modal" ref={ref} tabIndex={0} onKeyDown={handleKeyDown} onMouseDown={handleMouseDown}>
      <div className="modal__content">{children}</div>
    </article>
  );
};

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
};

Modal.defaultProps = {
  setShow: undefined,
  onClose: undefined,
};

export default Modal;
